import React, { useCallback, useEffect, useRef } from 'react';

import { ANYCOPY_WIDGET_MESSAGE_TYPES } from 'src/views/ExternalAnycopyWidget/utils';
import { useMobilePageIframeSrc } from './useMobilePageIframeSrc';
import { useMobilePageIframe } from './useMobilePageIframe';

const MobileDevicePage = () => {
  const ref = useRef();
  const iframeSrc = useMobilePageIframeSrc();
  const { iframeHeight } = useMobilePageIframe();

  const listener = useCallback(
    (event) => {
      if (event.data.type === ANYCOPY_WIDGET_MESSAGE_TYPES.anycopyWidgetScrollTo) {
        if (event.data.learnMore) {
          ref.current.scrollIntoView({ block: 'end', behavior: 'smooth' });
        } else {
          ref.current.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      }
    },
    [ref]
  );

  useEffect(() => {
    window.addEventListener('message', listener);
    return () => {
      window.removeEventListener('message', listener);
    };
  }, [listener]);

  return (
    <iframe
      title="mobile-lp"
      src={iframeSrc}
      ref={ref}
      allow="clipboard-read; clipboard-write"
      height={iframeHeight}
      width="100%"
    />
  );
};

export default MobileDevicePage;
